import { render, staticRenderFns } from "./GuidedTours.vue?vue&type=template&id=5d8d8d86&scoped=true&"
import script from "./GuidedTours.vue?vue&type=script&lang=js&"
export * from "./GuidedTours.vue?vue&type=script&lang=js&"
import style0 from "./GuidedTours.vue?vue&type=style&index=0&id=5d8d8d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d8d86",
  null
  
)

export default component.exports